<app-pcbread-crumb [data]="breadCrumb"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<ng-template #ModalContent let-modal class="modal-width">
  <app-drug-modal
    [activeAddModal]="activeAddModal"
    [thisValue]="thisValue!"
    [productType]="productType"
    (parentAction)="parentAction($event)"
  >

  </app-drug-modal>
</ng-template>

<!-- <app-pcedit-modal 
    [modalIsOpen]="openAddModal" [inputFields]="fields" [editSource]="thisValue"
    (parentAction)="parentAction($event)">
</app-pcedit-modal> -->

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  [inputModel]="modalConfirm"
  (childEvent)="parentAction($event)"
></app-pcconfrim-modal>
